import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: localStorage.getItem("auth_token"),
    user: JSON.parse(localStorage.getItem("auth_user") || "null"),
  },
  reducers: {
    login(state, action) {
      const { token, ...user } = action.payload;
      state.token = token;
      state.user = user;
      localStorage.setItem("auth_token", token);
      localStorage.setItem("auth_user", JSON.stringify(user));
    },
    logout(state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_user");
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
